import { useMemo } from 'react'
import useLayout from '@hook/shared/use-layout'
import useSessions from '@hook/shared/use-sessions'

export default function useLayoutHeight(): string {
  const { menuToggle } = useLayout()
  const { hasSessions } = useSessions()
  return useMemo(
    () =>
      menuToggle
        ? hasSessions
          ? 'calc(100vh - 30px)'
          : '100vh'
        : hasSessions
        ? 'calc(100vh - 160px)'
        : 'calc(100vh - 142px)',
    [menuToggle, hasSessions]
  )
}
